import React from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
export const settingsMenuItem = {
    icon: React.createElement(SettingOutlined, null),
    id: 'settings-menu-item',
    key: 'Settings',
    label: COPY_SPECIFIC.SETTINGS,
    route: FULL_ROUTES.SETTINGS
};
